// src/services/SmsService.js

import api from "../api/api";

const SmsService = {
    async sendSms(phoneNumber, trackingNumber, shipmentStatus) {
        try {
            const { data } = await api.post("/sms/send", {
                phoneNumber,
                trackingNumber,
                shipmentStatus
            });

            return data;
        }
        catch (error) {
            const msg =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "Failed to send SMS";

            throw new Error(msg);
        }
    }
};

export default SmsService;